import React from 'react';
import {
  ContentBannerSkeleton,
  Grid,
  GridItem,
  SectionHeaderSkeleton,
  SkeletonPlaceholder,
} from '@modernhealth/vital-components';

import { SessionCardRowSkeleton } from '../../components/SessionCardSkeletons';

export const SeriesPageSkeleton: React.FC = () => {
  return (
    <>
      <Grid>
        <GridItem lg={2} md={2} column>
          <SectionHeaderSkeleton />
          <SkeletonPlaceholder width={400} height={25} borderRadius={4} marginBottom={20} />
          <SkeletonPlaceholder width={400} height={25} borderRadius={4} marginBottom={20} />
          <SkeletonPlaceholder width={400} height={25} borderRadius={4} marginBottom={20} />
        </GridItem>
        <GridItem lg={3} md={2}>
          <ContentBannerSkeleton />
        </GridItem>
      </Grid>
      <SkeletonPlaceholder width={180} height={25} borderRadius={4} marginBottom={120} />
      <SessionCardRowSkeleton />
      <SessionCardRowSkeleton />
    </>
  );
};
